<div class="counter-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          {{action}} Serie Facturacion
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12 counter-content" (click)="setEditable()">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>Serie</mat-label>
              <input matInput type="text" name="serie" [formControl]="serieControl">
            </mat-form-field>
            <mat-error *ngIf="submitted && serieControl?.errors?.['required']">
              Serie Obligatoria
            </mat-error>
          </div>
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>N° última factura</mat-label>
              <input matInput type="number" name="seq" [formControl]="seqControl">
            </mat-form-field>
            <mat-hint></mat-hint>
          </div>
        </div>
        <div class="row">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>